<template>
  <breadcrumbs
    v-if="showBreadcrumbs"
    ref="breadcrumbs"
    :breadcrumbs="breadcrumbs"
  />

  <div
    v-else-if="showBackNav"
    ref="headerMobileBackNav"
    class="header-mobile-back-nav"
  >
    <a :href="mobileNav.href || '/'">{{ mobileNav.label }}</a>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import Breadcrumbs from 'components/Header/White/Breadcrumbs'
  import get from 'lodash-es/get'
  import CookieUtils from 'utils/CookieUtils'

  export default {
    components: {
      Breadcrumbs
    },
    computed: {
      ...mapGetters('device', ['isMobile']),
      ...mapState('main', ['pageType']),
      ...mapState('header', ['breadcrumbs']),
      isIndex() {
        return this.pageType === 'index'
      },
      showBreadcrumbs() {
        return get(this, 'breadcrumbs', []).length > 0 && !this.isMobile && !this.isIndex
      },
      showBackNav() {
        const param = CookieUtils.getCookie('btMobileApp')

        if (this.isMobile && param !== null) {
          return false
        }

        return get(this, 'breadcrumbs', []).length >= 2 && !this.isIndex
      },
      mobileNav() {
        return this.breadcrumbs[this.breadcrumbs.length - 2]
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';

  .header-mobile-back-nav {
    background-color: $blue-grey-light;
    position: relative;
    border-bottom: 1px solid $grey-border;
    font-family: $base-font-family;

    width: auto;
    max-width: $desktop-wide-width;

    @include bp-tablet {
      max-width: $tablet-wide-width;
    }

    @include bp-desktop-small {
      padding: 0 26px;
    }

    a {
      display: flex;
      align-items: center;
      position: relative;
      padding: 0 23px 0 45px;
      height: 48px;
      font-size: em(12);
      font-weight: 500;
      color: $blue-medium;
      text-decoration: none;

      &:before {
        content: $icon-arrow-left-thin;
        @include icon-font-thin();
        position: absolute;
        top: calc(50% - 9px);
        left: 23px;
        margin-right: 13px;
        font-size: em(19);
        line-height: 19px;
      }
    }
  }
</style>
